import React from "react";

import "./EditChartIcons.scss";

const Alarms = props => {
  const getClassName = () => {
    const styleClass = "chart-edit-icon";
    return props.active ? `${styleClass}-active` : styleClass;
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" className={getClassName()} disabled={props.disabled}>
      <g id="Edit_Alarms" data-name="Edit_Alarms" transform="translate(4 4)">
        <path id="Path_9605" data-name="Path 9605" fill="none" d="M0 0H32V32H0Z" transform="translate(-4 -4)" />
        <path
          id="Path_9606"
          data-name="Path 9606"
          className="icon-stroke icon-background"
          strokeMiterlimit="10"
          d="M4 21.182 13 5.637l9 15.545Z"
          transform="translate(-1 -1.409)"
        />
        <g id="Group_11201" data-name="Group 11201" transform="translate(11.556 9.75)">
          <rect id="Rectangle_810" data-name="Rectangle 810" className="icon-fill" width="1" height="1" transform="translate(0 6.721)" />
          <rect id="Rectangle_811" data-name="Rectangle 811" className="icon-fill" width="1" height="5.25" />
        </g>
      </g>
    </svg>
  );
};

export default Alarms;
